<template>
  <section id="hero">
    <v-parallax dark src="@/assets/img/bgHero.jpg" height="750">
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row align="center" justify="center">
            <v-col cols="12" md="6" xl="8">
              <h1 class="display-2 font-weight-bold mb-4">Recovery Email Server Of TitanAds Agency</h1>
              <h1 class="font-weight-light">
                Get the code for Hotmail below
              </h1>
              <v-row class="mt-5">
              <v-col cols="12" sm="8">
                <v-text-field
                    class="mt-5"
                    label="Put the recovery email here"
                    solo
                    v-model="emailaddress"
                    v-on:input="setNotError"
                    hide-details="auto"
                >
                </v-text-field>
              </v-col>
                <v-btn class="mt-2 mt-sm-7 ml-3" x-large color="success" @click="gotoEmail()">
                  Get Code
                </v-btn>


              </v-row>
              <v-row class="mt-0">
                <v-col cols="8">
                  <v-alert dense v-show="isVisibleError" type="error"> {{error}}</v-alert>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" md="6" xl="4" class="hidden-sm-and-down">

            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <div class="svg-border-waves text-white">
        <v-img src="@/assets/img/borderWaves.svg" />
      </div>
    </v-parallax>
<!--    <v-container fluid id="features" class="mt-2">-->
<!--      <v-row align="center" justify="center">-->
<!--        <v-col cols="10">-->
<!--          <v-row align="center" justify="space-around">-->
<!--            &lt;!&ndash; <v-col cols="12" class="text-center">-->
<!--              <h1 class="font-weight-light display-2">Title</h1>-->
<!--              <h1 class="font-weight-light">-->
<!--                Lorem ipsum dolor sit amet consectetur adipisicing elit.-->
<!--              </h1>-->
<!--            </v-col> &ndash;&gt;-->
<!--            <v-col-->
<!--              cols="12"-->
<!--              sm="4"-->
<!--              class="text-center"-->
<!--              v-for="(feature, i) in features"-->
<!--              :key="i"-->
<!--            >-->
<!--              <v-hover v-slot:default="{ hover }">-->
<!--                <v-card-->
<!--                  class="card"-->
<!--                  shaped-->
<!--                  :elevation="hover ? 10 : 4"-->
<!--                  :class="{ up: hover }"-->
<!--                >-->
<!--                  <v-img-->
<!--                    :src="feature.img"-->
<!--                    max-width="100px"-->
<!--                    class="d-block ml-auto mr-auto"-->
<!--                    :class="{ 'zoom-efect': hover }"-->
<!--                  ></v-img>-->
<!--                  <h1 class="font-weight-regular">{{ feature.title }}</h1>-->
<!--                  <h4 class="font-weight-regular subtitle-1">-->
<!--                    {{ feature.text }}-->
<!--                  </h4>-->
<!--                </v-card>-->
<!--              </v-hover>-->
<!--            </v-col>-->
<!--          </v-row>-->
<!--        </v-col>-->
<!--      </v-row>-->
<!--    </v-container>-->

    <div class="svg-border-waves">
      <img src="~@/assets/img/wave2.svg" />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      features: [
        {
          img: require("@/assets/img/icon2.png"),
          title: "Nhanh chóng",
          text: "Hệ thống mail server đạt chuẩn tốc độ.",
        },
        {
          img: require("@/assets/img/icon1.png"),
          title: "An toàn",
          text: "Hoàn toàn bảo mật, không mất mát dữ liệu.",
        },
        {
          img: require("@/assets/img/icon3.png"),
          title: "Dễ dàng",
          text: "Dễ dàng sử dụng chỉ với vài cú click.",
        },
      ],
      emailaddress: "",
      error: '',
      isVisibleError: false,
      reg: /.+@.+\..+/,
    };
  },
  methods: {
    setNotError() {
      this.isVisibleError = false
    },
    gotoEmail() {
      if (!this.reg.test(this.emailaddress)) {
        this.error = 'Invalid email address. Please try again!'
        this.isVisibleError = true
        return
      }
      this.$store.commit('SET_AUTH_TOKEN')
      this.$store.commit('SET_EMAIL', this.emailaddress)
      this.$store.dispatch('fetchMessages', this.emailaddress).then(()=>{
        this.$router.push({name: 'Email'})
      }).catch((err) =>{
        //this.$router.push({name: 'Email'})
        this.error = 'Invalid email address. Please try again!'
        this.isVisibleError = true
      })

    }
  },
};
</script>

<style lang="scss">
.circle {
  stroke: white;
  stroke-dasharray: 650;
  stroke-dashoffset: 650;
  -webkit-transition: all 0.5s ease-in-out;
  opacity: 0.3;
}

.playBut {
  /*  border: 1px solid red;*/
  display: inline-block;
  -webkit-transition: all 0.5s ease;

  .triangle {
    -webkit-transition: all 0.7s ease-in-out;
    stroke-dasharray: 240;
    stroke-dashoffset: 480;
    stroke: white;
    transform: translateY(0);
  }

  &:hover {
    .triangle {
      stroke-dashoffset: 0;
      opacity: 1;
      stroke: white;
      animation: nudge 0.7s ease-in-out;

      @keyframes nudge {
        0% {
          transform: translateX(0);
        }
        30% {
          transform: translateX(-5px);
        }
        50% {
          transform: translateX(5px);
        }
        70% {
          transform: translateX(-2px);
        }
        100% {
          transform: translateX(0);
        }
      }
    }

    .circle {
      stroke-dashoffset: 0;
      opacity: 1;
    }
  }
}
</style>

<style>
.btn-play {
  transition: 0.2s;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

#hero {
  z-index: 0;
}
.svg-border-waves img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  margin-bottom: -2px;
  z-index: -1;
}

.card {
  min-height: 300px;
  padding: 10px;
  transition: 0.5s ease-out;
}

.card .v-image {
  margin-bottom: 15px;
  transition: 0.75s;
}

.card h1 {
  margin-bottom: 10px;
}

.zoom-efect {
  transform: scale(1.1);
}

.up {
  transform: translateY(-20px);
  transition: 0.5s ease-out;
}
</style>

<style>
section {
  position: relative;
}
</style>
